// [file name]: validation.js
// [file content begin]
export const validation = {
  // Проверка обязательных полей
  chkFields: (fields, dataObj) => {
    return fields.every(item => {
      const keys = item.split('.');
      let value = dataObj;
      
      for (const key of keys) {
        value = value[key];
        if (value === undefined || value === null) return false;
      }
      
      return !!value;
    });
  },

  // Валидация email
  validateEmail: (email) => {
    if (!email) return true; // email не обязателен
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  },

  // Валидация ЕДРПОУ (8 цифр)
  validateEdrpou: (edrpou) => {
    if (!edrpou) return false;
    const edrpouRegex = /^\d{8}$/;
    return edrpouRegex.test(edrpou);
  },

  // Валидация номера садика (только цифры и буквы)
  validateNumber: (number) => {
    if (!number) return false;
    const numberRegex = /^[a-zA-Z0-9]+$/;
    return numberRegex.test(number);
  },

  // Валидация координат
  validateCoordinates: (lat, lon) => {
    if (lat === undefined || lon === undefined) return false;
    return lat >= -90 && lat <= 90 && lon >= -180 && lon <= 180;
  }
};
// [file content end]